'use client';

import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel, Stack, Typography, type SxProps } from '@mui/material';
import { useId, useState, type ReactNode } from 'react';
import { HelpIcon } from '@/components/shared/helpIcon';
import type { FieldValidation } from './validation/fieldValidation';
import { InputErrorIcon } from './validation/inputErrorIcon';
export interface FormFieldFrameControl {
  hasError: boolean;
  errorAdornment: ReactNode;
  onBlur: () => void;
  /** For text-like controls: pass as `id`, the label points at it with `htmlFor`. */
  inputId: string;
  /** For selects, whose combobox is not labelable: pass as `labelId` (`aria-labelledby`). */
  labelId: string;
}
export const FormFieldFrame = t0 => {
  const $ = _c(27);
  const {
    title,
    helpText,
    alwaysShowHelp: t1,
    validation,
    value: t2,
    showValidationError: t3,
    sx,
    children
  } = t0;
  const alwaysShowHelp = t1 === undefined ? false : t1;
  const value = t2 === undefined ? "" : t2;
  const showValidationError = t3 === undefined ? false : t3;
  const [touched, setTouched] = useState(false);
  const inputId = useId();
  const labelId = `${inputId}-label`;
  let t4;
  if ($[0] !== showValidationError || $[1] !== touched || $[2] !== validation || $[3] !== value) {
    t4 = (touched || showValidationError) && (validation ? !validation.validateInput(value) : false);
    $[0] = showValidationError;
    $[1] = touched;
    $[2] = validation;
    $[3] = value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const hasError = t4;
  let t5;
  if ($[5] !== hasError || $[6] !== validation || $[7] !== value) {
    t5 = hasError ? <InputErrorIcon errorMessage={validation?.errorMessage(value)} /> : null;
    $[5] = hasError;
    $[6] = validation;
    $[7] = value;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const errorAdornment = t5;
  let t6;
  if ($[9] !== sx) {
    t6 = {
      width: "100%",
      ...sx
    };
    $[9] = sx;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== alwaysShowHelp || $[12] !== helpText || $[13] !== inputId || $[14] !== labelId || $[15] !== title) {
    t7 = title && <FormLabel id={labelId} htmlFor={inputId}><Stack direction="row" sx={{
        alignItems: "center",
        gap: "4px",
        justifyContent: "flex-start"
      }}><Typography variant="subtitle1">{title}</Typography>{helpText && <HelpIcon title={helpText} alwaysVisible={alwaysShowHelp} className="text-(--mui-palette-text-secondary)" />}</Stack></FormLabel>;
    $[11] = alwaysShowHelp;
    $[12] = helpText;
    $[13] = inputId;
    $[14] = labelId;
    $[15] = title;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== children || $[18] !== errorAdornment || $[19] !== hasError || $[20] !== inputId || $[21] !== labelId) {
    t8 = typeof children === "function" ? children({
      hasError,
      errorAdornment,
      onBlur: () => setTouched(true),
      inputId,
      labelId
    }) : children;
    $[17] = children;
    $[18] = errorAdornment;
    $[19] = hasError;
    $[20] = inputId;
    $[21] = labelId;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <FormControl className="group/help" sx={t6}>{t7}{t8}</FormControl>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};